import React from "react";

export default function VaultActionAttention({ active, className = "", outline = false }) {
  if (!active) return null;
  return <span aria-hidden="true" className={`vg-vault-action-attention pointer-events-none absolute z-10 overflow-hidden ${outline ? "vg-meetup-attention-border" : ""} ${className}`} />;
}
